module.exports = __webpack_public_path__ + "static/AakashVerma-6f8143e865dc6e3abbaac06632a8a736.jpg";